module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_ui_Multitouch__;